
import APIResultMessage from "components/common/APIResultMessage";
import ErrorBoundary from "components/common/ErrorBoundary";
import Toolbar from "components/common/Toolbar";
import { Card, CardBody, CardHeader } from "reactstrap";

const DetailCard = ({ children, toolbarItems, success, saveError }) => {
    return (
        <ErrorBoundary fallback={<div>An error occurred in Details component.</div>}>
            <Card className="card-tasks" style={{ height: "auto", marginLeft: "10px", borderRadius: '0.875rem', overflow: 'visible' }}>
                {toolbarItems &&
                    <CardHeader>
                        <Toolbar items={toolbarItems.filter(item => item.visible)} />
                    </CardHeader>
                }
                <CardBody>
                <APIResultMessage success={success} error={saveError} />
                    {children}
                </CardBody>
            </Card>
        </ErrorBoundary>
    );
};

export default DetailCard;